module.exports = __webpack_public_path__ + "img/logo.6caa9acc.png";